import { Time } from '@instinet-analytics/core-lib';
import React from 'react';
import { TimeLabel } from 'utils/components/TimeLabel/TimeLabel.tsx';
import { useOrderVolumeProfileComponentSlice } from '../../store/component/componentSlice';
import { TimeRangeStreamData } from 'utils/components/TimeLabel/useTimeRange.ts';

export function OrderVolumeProfileTimeLabel({
    data,
}: {
    data: TimeRangeStreamData;
}) {
    const { component, dispatchComponentChanged } =
        useOrderVolumeProfileComponentSlice();

    const onChanged = (
        startTime: Time | undefined,
        endTime: Time | undefined
    ) => {
        dispatchComponentChanged({ startTime, endTime });
    };

    return (
        <TimeLabel component={component} data={data} onChanged={onChanged} />
    );
}
